<div [class.opened]="opened" class="wrapper flex flex-col gap-4 bg-primary px-2 pt-3 pb-8 h-full w-full">

  <div class="flex flex-col my-auto">

    @if (isEmployeeUser) {
      <button (click)="goToHome()" [class.active]="active === 'dashboard'" [class.btn-primary-outline]="active === 'dashboard'" class="btn menu-item">
        <img alt="Sidebar" class="filter-neutral-400" src="/assets/icons/feather/home.svg">
        <span class="label truncate">Vista general</span>
      </button>
    }

    @for (item of menu; track item.slug) {
      <button (click)="itemPressed(item)" [class.active]="active === item.slug"
              [class.btn-primary-outline]="active === item.slug"
              class="btn menu-item">
        @if (item.iconType === 'custom') {
          <img [src]="'/assets/icons/compliance/'+item.icon+'.svg'" alt="Sidebar" class=" filter-neutral-400">
        } @else if (item.icon) {
          <img [src]="'/assets/icons/feather/'+item.icon+'.svg'" alt="Sidebar" class=" filter-neutral-400">
        }
        <span class="label truncate">{{ item.label }}</span>
      </button>
    }

  </div>

  <hr class="w-full !mt-0"/>

  <div class="w-full">
    <button class="btn menu-item">
      <img alt="Sidebar" class=" filter-neutral-400" src="/assets/icons/compliance/cog.svg">
      <span class="label cd-text-b4">Configuración</span>
    </button>
    <button class="btn menu-item">
      <img alt="Sidebar" class=" filter-neutral-400" src="/assets/icons/compliance/user-profile.svg">
      <span class="label cd-text-b4">Perfil</span>
    </button>
    <button (click)="logout()" class="btn menu-item">
      <img alt="Sidebar" class=" filter-neutral-400" src="/assets/icons/compliance/logout.svg">
      <span class="label cd-text-b4">Salir</span>
    </button>
    @if (!authState.isAdmin() && hasCompanyLogo()) {
      <img alt="Company"
           class="w-full max-w-[3rem] max-h-[3rem] mx-auto rounded-full object-cover cursor-pointer"
           [class.opacity-60]="!canSelectCompany()"
           [src]="getCompanyLogoUrl(getCompanyId())"
           (click)="handleCompanyClick()"
           (error)="handleLogoError()">
    } @else {
      <img alt="Sidebar" class="w-full max-w-[6rem] mx-auto" src="/assets/icons/compliance/logo.svg">
    }
  </div>


</div>
